/**
 * Normalizes raw `display_name` from the public site-config JSON (`sites.label`).
 * Config objects from `loadPublicSiteConfig` already carry a normalized `display_name`; use `siteDisplayNameFromLoadedConfig` there.
 */
export function normalizePublicSiteDisplayName(value: unknown): string | null {
	if (typeof value !== "string") {
		return null;
	}
	const trimmed = value.trim();
	if (trimmed === "LeCoffre notaire (IdNot)") {
		return null;
	}
	if (trimmed.length > 0) {
		return trimmed;
	}
	return null;
}
